import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, vShow as _vShow, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-1f924874")

_pushScopeId("data-v-1f924874")
const _hoisted_1 = /*#__PURE__*/_createVNode("h1", null, "Slevové kódy", -1)
const _hoisted_2 = { class: "create-verify" }
const _hoisted_3 = {
  key: 1,
  class: "content"
}
const _hoisted_4 = { class: "results" }
const _hoisted_5 = { class: "group" }
const _hoisted_6 = { class: "box" }
const _hoisted_7 = { class: "wrap error" }
const _hoisted_8 = /*#__PURE__*/_createVNode("h2", { class: "error" }, "Error:", -1)
const _hoisted_9 = {
  key: 0,
  class: "errordetail"
}
const _hoisted_10 = {
  key: 1,
  class: "errordetail"
}
const _hoisted_11 = { class: "divide-elements" }
const _hoisted_12 = { class: "element-first" }
const _hoisted_13 = { class: "element-second" }
const _hoisted_14 = { class: "divide-elements" }
const _hoisted_15 = { class: "element-first" }
const _hoisted_16 = { class: "element-first element-second" }
const _hoisted_17 = { class: "data second" }
const _hoisted_18 = { class: "input-border first" }
const _hoisted_19 = /*#__PURE__*/_createVNode("label", { for: "date" }, null, -1)
const _hoisted_20 = /*#__PURE__*/_createVNode("span", { class: "text" }, "Platnost od", -1)
const _hoisted_21 = { class: "group" }
const _hoisted_22 = { class: "border-gr short date" }
const _hoisted_23 = { class: "input-border" }
const _hoisted_24 = /*#__PURE__*/_createVNode("label", { for: "date" }, null, -1)
const _hoisted_25 = /*#__PURE__*/_createVNode("span", { class: "text" }, "Platnost do", -1)
const _hoisted_26 = { class: "group" }
const _hoisted_27 = { class: "border-gr short" }
const _hoisted_28 = { class: "data second" }
const _hoisted_29 = { class: "divide-elements" }
const _hoisted_30 = { class: "element-first" }
const _hoisted_31 = { class: "element-first element-second" }
const _hoisted_32 = { class: "end-form" }
const _hoisted_33 = { class: "data second" }
const _hoisted_34 = { class: "text" }
const _hoisted_35 = { class: "group" }
const _hoisted_36 = { class: "end-form" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_EventResult = _resolveComponent("EventResult")
  const _component_Loader = _resolveComponent("Loader")
  const _component_TheCountry = _resolveComponent("TheCountry")
  const _component_TheName = _resolveComponent("TheName")
  const _component_TheCodesCount = _resolveComponent("TheCodesCount")
  const _component_TheCodesCountOnePromocode = _resolveComponent("TheCodesCountOnePromocode")
  const _component_TheCodesCountMultiplePromocode = _resolveComponent("TheCodesCountMultiplePromocode")
  const _component_TheNumberOfUses = _resolveComponent("TheNumberOfUses")
  const _component_TheNumberOfUsers = _resolveComponent("TheNumberOfUsers")
  const _component_TheTypeOfValue = _resolveComponent("TheTypeOfValue")
  const _component_TheValue = _resolveComponent("TheValue")
  const _component_TheFinalPrice = _resolveComponent("TheFinalPrice")
  const _component_TheTypeOfCode = _resolveComponent("TheTypeOfCode")
  const _component_TheResults = _resolveComponent("TheResults")
  const _component_ThePromocodeList = _resolveComponent("ThePromocodeList")
  const _component_TheConsumerGroupList = _resolveComponent("TheConsumerGroupList")

  return (_openBlock(), _createBlock("div", {
    class: "container-promocode",
    onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.resetEvent && _ctx.resetEvent(...args)))
  }, [
    _hoisted_1,
    _createVNode("div", _hoisted_2, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.tabs, (tab) => {
        return (_openBlock(), _createBlock("span", {
          key: tab,
          onClick: ($event: any) => (_ctx.activeTab = tab.order),
          class: { active : _ctx.activeTab === tab.order }
        }, _toDisplayString(tab.name), 11, ["onClick"]))
      }), 128))
    ]),
    _createVNode(_component_EventResult, {
      title: _ctx.eventTitle,
      description: _ctx.eventDescription
    }, null, 8, ["title", "description"]),
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_Loader, { key: 0 }))
      : _createCommentVNode("", true),
    (!_ctx.loading && _ctx.error)
      ? (_openBlock(), _createBlock("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, [
            _createVNode("div", _hoisted_5, [
              _createVNode("div", _hoisted_6, [
                _createVNode("div", _hoisted_7, [
                  _hoisted_8,
                  (_ctx.errorMsg)
                    ? (_openBlock(), _createBlock("p", _hoisted_9, _toDisplayString(_ctx.errorMsg), 1))
                    : (_openBlock(), _createBlock("p", _hoisted_10, "No detailed error message."))
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.activeTab === 1)
      ? (_openBlock(), _createBlock("form", {
          key: 2,
          action: "",
          onSubmit: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)), ["prevent"])),
          autocomplete: "off"
        }, [
          _createVNode("div", _hoisted_11, [
            _createVNode("div", _hoisted_12, [
              _createVNode(_component_TheCountry, {
                countries: _ctx.consignedCountries,
                title: "Stát podání zásilky",
                name: "consignCountries",
                onlyOneCountry: true
              }, null, 8, ["countries"])
            ]),
            _createVNode("div", _hoisted_13, [
              _createVNode(_component_TheCountry, {
                countries: _ctx.targetCountries,
                title: "Stát příjemce zásilky",
                name: "targetCountries",
                onlyOneCountry: false
              }, null, 8, ["countries"])
            ])
          ]),
          _createVNode(_component_TheName, {
            name: _ctx.showTitle,
            onPrintName: _ctx.printName
          }, null, 8, ["name", "onPrintName"]),
          _createVNode("div", _hoisted_14, [
            _createVNode("div", _hoisted_15, [
              _createVNode(_component_TheCodesCount, {
                onPrintCodesCountId: _ctx.printCodesCountId,
                onPrintCodesCountName: _ctx.printCodesCountName,
                onPrintCodeMask: _ctx.printCodeMask,
                onPrintCode: _ctx.printCode,
                onPrintCodesCount: _ctx.printCodesCount,
                "codes-count-id": _ctx.codesCountId,
                "codes-count-name": _ctx.codesCountName,
                "is-editing": _ctx.isEditing
              }, null, 8, ["onPrintCodesCountId", "onPrintCodesCountName", "onPrintCodeMask", "onPrintCode", "onPrintCodesCount", "codes-count-id", "codes-count-name", "is-editing"])
            ]),
            _createVNode("div", _hoisted_16, [
              (_ctx.codesCountId === 1)
                ? (_openBlock(), _createBlock(_component_TheCodesCountOnePromocode, {
                    key: 0,
                    onPrintCode: _ctx.printCode,
                    code: _ctx.code,
                    "is-editing": _ctx.isEditing
                  }, null, 8, ["onPrintCode", "code", "is-editing"]))
                : _createCommentVNode("", true),
              (_ctx.codesCountId === 2)
                ? (_openBlock(), _createBlock(_component_TheCodesCountMultiplePromocode, {
                    key: 1,
                    onPrintCodeMask: _ctx.printCodeMask,
                    onPrintCodesCount: _ctx.printCodesCount,
                    "codes-count": _ctx.codesCount,
                    "code-length": _ctx.codeLenght,
                    "is-editing": _ctx.isEditing
                  }, null, 8, ["onPrintCodeMask", "onPrintCodesCount", "codes-count", "code-length", "is-editing"]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createVNode("div", _hoisted_17, [
            _createVNode("div", _hoisted_18, [
              _hoisted_19,
              _hoisted_20,
              _createVNode("div", _hoisted_21, [
                _createVNode("div", _hoisted_22, [
                  _withDirectives(_createVNode("input", {
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.dateFrom = $event)),
                    id: "dateFrom",
                    type: "text",
                    autocomplete: "nope"
                  }, null, 512), [
                    [_vModelText, _ctx.dateFrom]
                  ])
                ])
              ])
            ]),
            _createVNode("div", _hoisted_23, [
              _hoisted_24,
              _hoisted_25,
              _createVNode("div", _hoisted_26, [
                _createVNode("div", _hoisted_27, [
                  _withDirectives(_createVNode("input", {
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.dateTo = $event)),
                    id: "dateTo",
                    type: "text",
                    autocomplete: "nope"
                  }, null, 512), [
                    [_vModelText, _ctx.dateTo]
                  ])
                ])
              ])
            ])
          ]),
          _createVNode("div", _hoisted_28, [
            _createVNode(_component_TheNumberOfUses, {
              onPrintNumberOfUses: _ctx.printNumberOfUses,
              numberOfUses: _ctx.numberOfUses
            }, null, 8, ["onPrintNumberOfUses", "numberOfUses"]),
            _createVNode(_component_TheNumberOfUsers, {
              onPrintNumberOfUsers: _ctx.printNumberOfUsers,
              numberOfUsers: _ctx.numberOfUsers
            }, null, 8, ["onPrintNumberOfUsers", "numberOfUsers"])
          ]),
          _createVNode("div", _hoisted_29, [
            _createVNode("div", _hoisted_30, [
              _createVNode(_component_TheTypeOfValue, {
                onPrintApplierId: _ctx.printApplierId,
                onPrintApplierName: _ctx.printApplierName,
                "applier-id": _ctx.applierId,
                "applier-name": _ctx.applierName,
                "promocode-appliers": _ctx.appliers
              }, null, 8, ["onPrintApplierId", "onPrintApplierName", "applier-id", "applier-name", "promocode-appliers"])
            ]),
            _createVNode("div", _hoisted_31, [
              (_ctx.applierId !== 4)
                ? (_openBlock(), _createBlock(_component_TheValue, {
                    key: 0,
                    onPrintDiscountValue: _ctx.printDiscountValue,
                    onPrintDiscountCurrency: _ctx.printDiscountCurrency,
                    "applier-id": _ctx.applierId,
                    "discount-value": _ctx.showValue,
                    "discount-currency": _ctx.showValueCurrency
                  }, null, 8, ["onPrintDiscountValue", "onPrintDiscountCurrency", "applier-id", "discount-value", "discount-currency"]))
                : _createCommentVNode("", true),
              (_ctx.applierId === 4)
                ? (_openBlock(), _createBlock(_component_TheFinalPrice, {
                    key: 1,
                    onPrintFinalPrice: _ctx.printFinalPrice,
                    onPrintDiscountCurrency: _ctx.printDiscountCurrency,
                    "applier-id": _ctx.applierId,
                    "final-price": _ctx.finalPrice,
                    "discount-currency": _ctx.showValueCurrency
                  }, null, 8, ["onPrintFinalPrice", "onPrintDiscountCurrency", "applier-id", "final-price", "discount-currency"]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createVNode(_component_TheTypeOfCode, {
            onPrintCodeType: _ctx.printCodeType,
            onApplyConfiguration: _ctx.applyPromocodeConfiguration,
            "consumer-groups": _ctx.consumerGroups,
            "promocode-type": _ctx.type,
            "mobile-user-count-of-packets": _ctx.mobileUserCountOfPackets,
            "promocode-consumer-group": _ctx.promocodeConsumerGroup,
            "mobile-user-any-packet-bds-to-branch-latest-packet-date": _ctx.mobileUserAnyPacketBdsToBranchLatestPacketDate,
            "destination-types": _ctx.destinationTypes
          }, null, 8, ["onPrintCodeType", "onApplyConfiguration", "consumer-groups", "promocode-type", "mobile-user-count-of-packets", "promocode-consumer-group", "mobile-user-any-packet-bds-to-branch-latest-packet-date", "destination-types"]),
          _createVNode("div", _hoisted_32, [
            _createVNode("button", {
              class: "convert",
              type: "button",
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.saveDiscount && _ctx.saveDiscount(...args)))
            }, "Zveřejnit")
          ])
        ], 32))
      : _createCommentVNode("", true),
    (_ctx.activeTab === 2)
      ? (_openBlock(), _createBlock("form", {
          key: 3,
          action: "",
          onSubmit: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)), ["prevent"])),
          autocomplete: "off"
        }, [
          _createVNode("div", _hoisted_33, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.inputs, (input, index) => {
              return (_openBlock(), _createBlock("div", {
                class: ["input-border", input.class],
                key: input
              }, [
                _createVNode("label", {
                  for: input.label
                }, null, 8, ["for"]),
                _createVNode("span", _hoisted_34, _toDisplayString(input.title), 1),
                _createVNode("div", _hoisted_35, [
                  (_openBlock(), _createBlock("div", {
                    class: ["border-gr short", _ctx.classTest],
                    key: index
                  }, [
                    _withDirectives((_openBlock(), _createBlock("input", {
                      "onUpdate:modelValue": ($event: any) => (_ctx.values[index] = $event),
                      key: index,
                      name: input.label,
                      type: "text",
                      autocomplete: "nope"
                    }, null, 8, ["onUpdate:modelValue", "name"])), [
                      [
                        _vModelText,
                        _ctx.values[index],
                        void 0,
                        { lazy: true }
                      ]
                    ]),
                    _withDirectives(_createVNode("p", {
                      class: ["errorMessage", _ctx.classTest]
                    }, _toDisplayString(_ctx.errorMessage[index]), 3), [
                      [_vShow, _ctx.validity === true]
                    ])
                  ], 2))
                ])
              ], 2))
            }), 128))
          ]),
          _createVNode("div", _hoisted_36, [
            (_ctx.validity === true)
              ? (_openBlock(), _createBlock("div", {
                  key: 0,
                  class: ["message-validation", _ctx.classTest]
                }, [
                  _createVNode("p", null, "Uživatel " + _toDisplayString(_ctx.checkMsg) + " promokód " + _toDisplayString(_ctx.values[1]) + " využít.", 1)
                ], 2))
              : _createCommentVNode("", true),
            _createVNode("button", {
              class: "convert",
              type: "submit",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.toggleBtn()))
            }, "Ověřit promokód")
          ]),
          (_ctx.validityTest === 'valid')
            ? (_openBlock(), _createBlock(_component_TheResults, {
                key: 0,
                values: _ctx.values
              }, null, 8, ["values"]))
            : _createCommentVNode("", true)
        ], 32))
      : _createCommentVNode("", true),
    (_ctx.activeTab === 3)
      ? (_openBlock(), _createBlock("form", {
          key: 4,
          action: "",
          onSubmit: _cache[7] || (_cache[7] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)), ["prevent"])),
          autocomplete: "off"
        }, [
          _createVNode(_component_ThePromocodeList, {
            promocodes: _ctx.discounts,
            appliers: _ctx.appliers,
            onRefreshPromocodes: _ctx.refreshPromocodes,
            onStartLoading: _ctx.startLoading,
            onEditPromocode: _ctx.editDiscount,
            onInvokeError: _ctx.invokeError,
            onInvokeSuccess: _ctx.invokeSuccess
          }, null, 8, ["promocodes", "appliers", "onRefreshPromocodes", "onStartLoading", "onEditPromocode", "onInvokeError", "onInvokeSuccess"])
        ], 32))
      : _createCommentVNode("", true),
    (_ctx.activeTab === 4)
      ? (_openBlock(), _createBlock("form", {
          key: 5,
          action: "",
          onSubmit: _cache[8] || (_cache[8] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)), ["prevent"])),
          autocomplete: "off"
        }, [
          _createVNode(_component_TheConsumerGroupList, {
            "consumer-groups": _ctx.consumerGroups,
            onStartLoading: _ctx.startLoading,
            onFinishLoading: _ctx.finishLoading,
            onRefreshConsumerGroups: _ctx.refreshConsumerGroups,
            onInvokeError: _ctx.invokeError,
            onInvokeSuccess: _ctx.invokeSuccess
          }, null, 8, ["consumer-groups", "onStartLoading", "onFinishLoading", "onRefreshConsumerGroups", "onInvokeError", "onInvokeSuccess"])
        ], 32))
      : _createCommentVNode("", true)
  ]))
})